const styleGallery = {
    columnTitle: {
        width: '42%'
    },
    columnDate: {
        width: '20%'
    },
    columnLong: {
        width: '19%'
    },
    columnStatus: {
        width: '19%'
    },
    columnCell: {
        padding: 0,
        whiteSpace: 'normal'
    }
};

export default styleGallery;



// WEBPACK FOOTER //
// src/components/media/media-gallery-style.js